<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          System Level Tags
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New
            Tag</vs-button>
        </h3>
        <p class="card-subtitle">
          List of Default Tags to System (Used by - Posts)
        </p>
        <vs-row>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input icon-after="true" label-placeholder="Search by Tag Culture or Tag Name" icon="search"
              @keypress.enter="searchData()" v-model="search" />
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-button color="primary" type="filled" class="searchBtn" @click="searchData()"
              icon="search">Search</vs-button>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-button color="warning" type="filled" class="searchBtn" icon="cached"
              @click="resetData()">Reset</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <th>Tag Name</th>
            <th>Tag Language Culture</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item._id">
            <td>{{ index + 1 }}</td>
            <td class="td">{{ item.name }}</td>
            <td class="td text-center">
              {{ item.language }}
              <div class="d-flex" v-if="item.languageCount">
                <div class="progress-bar-container mt-3">
                  <div class="progress-bar p-2" :style="{
                    color: item.languageCount - item.missingLanguages.length === item.languageCount ? 'white' : 'black',
                    backgroundColor: item.missingLanguages.length > 0 ? 'red' : item.missingLanguages.length > 1 ? '#06b800' : '',
                    width:
                      ((item.languageCount - item.missingLanguages.length) / item.languageCount) * 100 + '%'
                  }">
                    <div class="absoluteText">
                      {{ item.languageCount - item.missingLanguages.length }}/{{ item.languageCount }}
                    </div>
                  </div>
                </div>
                <div class="text-center mt-2 d-flex align-items-center" style="font-weight: 800;">
                  <div style="width: 20px; height: 20px; margin-left: 5px" v-popover:tooltip="item.tooltipContent">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12" y2="8"></line>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
            <td class="td">
              <vs-button class="mr15" size="small" icon="create" color="warning"
                @click="editingItem(item)">Edit</vs-button>
              <vs-button class="mr15" size="small" color="danger" icon="delete_sweep" @click="
                deleteTagPopup = true;
              itemToDelete = item;
              ">Delete</vs-button>
              <vs-button icon="visibility" class="mr15" size="small" color="primary" @click="viewAllPosts(item)">View
                All Posts</vs-button>
            </td>
          </tr>
        </table>

        <!-- Code -->
        <vs-popup class="holamundo" :title="isNew ? 'Add New Tag' : 'Edit Tag'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12" class="mb15">
              <vs-select :color="colorx" label="Language Filter" @change="fileterusingLanguage($event, tag)"
                v-model="tag.language" icon="arrow_downward" :disabled="isNew">
                <vs-select-item value text="All Languages" />
                <vs-select-item :key="index" :value="item.culture" :text="item.culture"
                  v-for="(item, index) in languages" />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-input class="searchBtn" label="Tag Name" v-model="tag.name" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <vs-button icon="save" @click="btnAddTag">{{ isNew ? 'Save English' : 'Update one' }}</vs-button>
              <vs-button @click="createAndTranslate" class="ml-3" v-if="isNew">Save and Translate</vs-button>
              <vs-button @click="updateAndTranslate" class="ml-3" v-if="!isNew && tag.language === 'EN'">Update all and
                Translate</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete Tag" :active.sync="deleteTagPopup">
          <p>Are you sure you want to delete Tag?</p>
          <div>
            <vs-button class="mr15" @click="deleteTag">Delete Tag</vs-button>
            <vs-button @click="deleteTagPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
    <tooltip :width="300" :pointer="true">
    </tooltip>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import Vue from 'vue'
import VPopover from 'vue-js-popover'

Vue.use(VPopover, { tooltip: true })

export default {
  name: "Tag",
  data: () => ({
    title: "Tag",
    colorx: "#0D2144",
    defaultalert: false,
    deleteTagPopup: false,
    isNew: true,
    search: "",
    tag: {
      name: "",
      language: "",
      ref: "",
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
  }),
  methods: {
    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.tag = {
        name: "",
        language: "EN",
      };
    },
    editingItem(i) {
      this.$data.tag = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
    },
    btnAddTag() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      if (this.$data.tag.language === "" || this.$data.tag.name === "") {
        this.$vs.notify({
          title: "Error",
          text: "Please fill all fields",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$vs.loading();
      let apiToCall = API.INSERT_TAG;
      let data = this.$data.tag;
      if (!this.$data.isNew) {
        apiToCall = API.UPDATE_TAG;

        api.put(`${apiToCall}/${this.$data.tag._id}`, data, { headers })
          .then((r) => {
            this.$vs.loading.close();
            if (r.status === 200) {
              this.$vs.notify({
                title: "Success",
                text: "Saved Successfully",
                color: "success",
                position: "top-right",
              });
              this.$data.isNew = true;
              this.$data.itemToUpdate = "";
              this.$data.defaultalert = false;
              this.$data.tag = {};
              this.fetchAllTag();
            } else {
              this.$vs.notify({
                title: "Error",
                text: r.data.error,
                color: "danger",
                position: "top-right",
              });
            }
          })
          .catch(() => {
            this.$vs.loading.close();
          });

      } else {
        api
          .post(apiToCall, data, { headers })
          .then((r) => {
            this.$vs.loading.close();
            if (r.status === 200) {
              this.$vs.notify({
                title: "Success",
                text: "Saved Successfully",
                color: "success",
                position: "top-right",
              });
              this.$data.isNew = true;
              this.$data.itemToUpdate = "";
              this.$data.defaultalert = false;
              this.$data.tag = {};
              this.fetchAllTag();
            } else {
              this.$vs.notify({
                title: "Error",
                text: r.data.error,
                color: "danger",
                position: "top-right",
              });
            }
          })
          .catch(() => {
            this.$vs.loading.close();
          });
      }
    },
    createAndTranslate() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      if (this.$data.tag.language === "" || this.$data.tag.name === "") {
        this.$vs.notify({
          title: "Error",
          text: "Please fill all fields",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$vs.loading();
      let apiToCall = API.C_AND_T_TAG;
      let data = this.$data.tag;

      api.post(apiToCall, data, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              title: "Success",
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            this.$data.tag = {};
            this.fetchAllTag();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    updateAndTranslate() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      if (this.$data.tag.language === "" || this.$data.tag.name === "") {
        this.$vs.notify({
          title: "Error",
          text: "Please fill all fields",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$vs.loading();
      let apiToCall = API.U_AND_T_TAG;
      let data = this.$data.tag;

      api.put(`${apiToCall}/${this.$data.tag._id}`, data, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              title: "Success",
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            this.$data.tag = {};
            this.fetchAllTag();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    fetchAllTag() {
      this.$vs.loading();
      api
        .get(`${API.GET_TAG}?language=EN`, {})
        .then((r) => {
          this.$vs.loading.close();
          for (const item of r.data) {
            item.tooltipContent = item.missingLanguages.length > 0 ? 'Missing Languages: ' + item.missingLanguages.join(', ') : 'All Languages are translated';
          }
          this.$data.all = r.data;
          if (!r.status === 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => { });
    },
    deleteTag() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(`${API.DELETE_TAG}/${this.$data.itemToDelete._id}`, {}, { headers })
        .then((r) => {
          if (r.status === 200) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deleteTagPopup = false;
          this.fetchAllTag();
        })
        .catch(() => { });
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data
          if (!r.status == 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => { });
    },
    searchData() {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .get(`${API.SEARCH_TAG}?search=${this.$data.search}`, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          this.$data.all = r.data;
          if (!r.status == 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "Error",
            color: "danger",
            position: "top-right",
          });
        });
    },
    resetData() {
      this.fetchAllTag();
      this.$data.search = "";
    },
    viewAllPosts(i) {
      this.$router.push("/post/tag/?tagName=" + i.name + "&tagLang=" + i.language);
    },
    fileterusingLanguage(event, item) {
      if (event) {
        let headers = {
          "Content-Type": "application/json;charset=utf-18",
        };
        if (JSON.parse(localStorage.user).token) {
          headers["token"] = this.$data.token;
        }
        if (!this.isNew) {
          let id = item.ref || item._id;
          this.$vs.loading();
          api.get(`${API.GET_SINGLE_TAG}/${id}?language=${event}`, { headers })
            .then((r) => {
              this.$data.tag = Object.assign({}, r.data);
              this.resetData();
              this.$vs.loading.close();
            })
            .catch(() => {
              this.$vs.loading.close();
            });
        }
      }
    },
  },
  created() {
    this.fetchAllTag();
    this.fetchAllLanguages();
  },
};
</script>

<style scoped>
.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.searchBtn {
  margin-top: 15px;
  width: 40%;
}

.progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px rgba(0, 0, 0, 0.068) solid;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-bar {
  height: 10px;
  transition: width 0.3s ease;
}

.absoluteText {
  text-align: start;
}
</style>
